import {InventoryRequest} from "../../../../api/Logistics";
import {Dialog, ListItemText, MenuItem, Tooltip} from "@mui/material";
import {useNavigate} from "react-router-dom";
import {RowActionsBase} from "../../quote/openings/RowActions";
import {useSnackAction} from "../hardware/SnackAction";
import {api} from "../../../../api/API";
import {useProjectId} from "../ProjectName";
import {useConfirm} from "../../../../misc/Confirm";
import {canSendDuplicate} from "./BulkSendDuplicate";
import {useState} from "react";
import {useUser} from "../../../../misc/Permission";
import {ArchiveItemsForm, canArchive} from "./ArchiveItemsForm";

export function RowActions(props: {
    row: InventoryRequest;
    type: string;
}) {
    const project = useProjectId();
    const confirm = useConfirm();
    const nav = useNavigate();
    const archiveEnabled = useUser()?.role === "admin";
    const [archiveOpen, setArchiveOpen] = useState(false);

    const sendDuplicate = useSnackAction(async (input: {ids: number[]; project: number}) => {
        await api.logistics.sendDuplicate(input);
        nav(`/project/${project}/logictrl/changes`);
    }, {
        success: "Duplicate added to the changeset",
    });

    const canDuplicate = canSendDuplicate(props.row);

    return (
        <>
            <RowActionsBase>
                {onClose => <>
                    <Tooltip title={canDuplicate ? "" : "Only released items can be duplicated"}>
                        <span>
                            <MenuItem disabled={!canDuplicate || sendDuplicate.loading} onClick={async () => {
                                onClose();

                                const ok = await confirm.confirm(`Send a duplicate of "${props.row.name}" for ${props.row.openingName}? This opens a changeset with the new logistics item.`).catch(() => false);
                                if(!ok) return;

                                sendDuplicate.callback({ids: [props.row.id], project: project});
                            }}>
                                <ListItemText>Send Duplicate</ListItemText>
                            </MenuItem>
                        </span>
                    </Tooltip>
                    {archiveEnabled && <MenuItem disabled={!canArchive(props.row)} onClick={() => {
                        onClose();
                        setArchiveOpen(true);
                    }}>
                        <ListItemText>Archive</ListItemText>
                    </MenuItem>}
                </>}
            </RowActionsBase>

            {/* outside RowActionsBase: its popover unmounts on close and would take the dialog with it */}
            {archiveOpen && <Dialog open onClose={() => setArchiveOpen(false)}>
                <ArchiveItemsForm type={props.type} rows={[props.row]} onCancel={() => setArchiveOpen(false)} onArchived={() => setArchiveOpen(false)} />
            </Dialog>}
        </>
    );
}
